var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"endorse-payment"},[_c('payment',{attrs:{"orderId":_vm.orderId,"form":_vm.form,"policyModifyId":_vm.policyModifyId,"type":"endorsement"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }